import BeneficiaryService from './beneficiary-service'
import CustomerLoyaltyService from './customer-loyalty-service'
import CustomerService from './customer-service'
import EKYCService from './ekyc-service'
import ExchangeRateService from './exchange-rate-service'
import MiscService from './misc-service'
import OTPService from './otp-service'
import RegistrationService from './registration-service'
import SettlementService from './settlement-service'
import StaticDataService from './static-data-service'
import TokenService from './token-service'
import TransactionService from './transaction-service'
import PushNotificationService from './push-notification-service'

export const $api = {
  beneficiary       : BeneficiaryService,
  customerLoyalty   : CustomerLoyaltyService,
  customer          : CustomerService,
  ekycService       : EKYCService,
  exchangeRate      : ExchangeRateService,
  misc              : MiscService,
  otp               : OTPService,
  registration      : RegistrationService,
  settlement        : SettlementService,
  staticData        : StaticDataService,
  token             : TokenService,
  transaction       : TransactionService,
  pushnotification  : PushNotificationService,
};